
import { useEffect } from "react";
import { InputContainer } from "./form/form.module";
import { InputLabelContainer } from "./form/label/containers/input-label.container";


export const PaymentStatusActionComponent = ({
    value,
    error,
    onPaymentFormChange,
    dataId,
    paymentValues,
    paymentLibrary
}: any) => {

    return (


        <>
            {(dataId?.PaymentMethodId === 10 && value !== 30) ? (
                <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                        {/* Order Total*/}
                        <div className="flex flex-col">
                            <InputLabelContainer label="Order Total" />
                            <div className="text-gray-800 font-semibold mt-1">
                                {/* {currency(dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal)} */}
                                {`₹ ${dataId?.OrderTotal}`}
                            </div>
                        </div>

                        {/* Balance Amount */}
                        <div className="flex flex-col">
                            <InputLabelContainer label="Balance Amount" />
                            <div className="text-gray-800 font-semibold mt-1">
                                {`₹ ${dataId?.BalanceAmount || 0} `}
                            </div>
                        </div>

                        {/* Payment Status */}
                        <div>
                            <InputContainer

                                label="Payment Status"
                                labelField="Text"
                                list={paymentLibrary}
                                onValueChange={(event: any) => {
                                    onPaymentFormChange({
                                        fieldValue: event.target.value,
                                        field: 'PaymentStatusId'
                                    });

                                }}
                                type="select"
                                optionName="Choose Payment Status"
                                value={paymentValues?.PaymentStatusId || value}
                                valueField="Value"
                            />
                        </div>

                        {/* Paid Amount */}
                        <div>
                            <InputContainer
                                label="Paid Amount"
                                name="PaidAmount"
                                onValueChange={(event: any, _newValue: any) => {
                                    onPaymentFormChange({
                                        fieldValue: event.target.value,
                                        field: 'PaidAmount'
                                    });
                                }}
                                type="number"
                                value={paymentValues?.PaidAmount}
                            />
                            {error && (
                                <span className="text-red-600 text-xs">{error}</span>
                            )}
                        </div>
                    </div>


                </>
            ) : <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                    <div className="flex flex-col">
                        <InputLabelContainer label="Order Total" />
                        <div className="text-gray-800 font-semibold mt-1">
                            {/* {currency(dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal)} */}
                            {`₹ ${dataId?.OrderTotal}`}
                        </div>
                    </div>

                    <div className="flex flex-col">
                        <InputLabelContainer label="Balance Amount" />
                        <div className="text-gray-800 font-semibold mt-1">
                            {`₹ ${dataId?.BalanceAmount || 0} `}
                        </div>
                    </div>

                    <InputContainer
                        isDisabled
                        label="Payment Status"
                        labelField="Text"
                        list={paymentLibrary}
                        onValueChange={(event: any) => {
                            onPaymentFormChange({
                                fieldValue: event.target.value,
                                field: 'PaymentStatusId'
                            });
                        }}
                        type="select"
                        value={paymentValues?.PaymentStatusId || value}
                        valueField="Value"
                    />
                    <InputContainer
                        isDisabled
                        label="Paid Amount"
                        name="PaidAmount"
                        onValueChange={(event: any, _newValue: any) => {
                            onPaymentFormChange({
                                fieldValue: event.target.value,
                                field: 'PaidAmount'
                            });
                        }}
                        type="number"
                        value={dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal}
                    />
                </div>
            </>
            }
        </>



    );
};
